const ROUTES = {
  LOGIN: "/login",
  PERMISSIONS: "/permissions",
  LOGOUT: "/logout",
  ERROR: "/error",
};

export default ROUTES;
